<template>
  <div class="add-cart">
    <van-actionsheet v-model="isShow" :close-on-click-overlay="false">
      <div class="header-part">
        <section class="goods-info">
          <div class="goods-img">
            <img class="" :src="myChoose.imgUrl" alt=""  @click="changeShowMaxImg"/>
            <div
              v-show="myChoose.hasPromoSticker"
              v-for="item in myChoose.promoStickerInfo"
            >
              <PromoSticker :src="item.mktIcon"></PromoSticker>
            </div>
          </div>
          <div class="goods-price-wrap">
            <!-- <div class="vip-price">
              <BusinessCoupon
                :discountPrice="myChoose.discountPrice"
                :discount="myChoose.discount"
                :discountTagShow="myChoose.discountTagShow"
                :mktTagShow="myChoose.mktTagShow"
                showType="detail"
              ></BusinessCoupon>
            </div>
            <div v-if="myChoose.hasPromoTags" class="promo-price-wrap">
              <div class="add-promo-price">
                <img :src="unionIcon" alt="" />
                <span>{{ parseFloat(((myChoose.tags.promPrice ? myChoose.tags.promPrice : myChoose.tags.salePrice ? myChoose.tags.salePrice : myChoose.price) * unionScale).toFixed(2) || 0) }}</span>
              </div>
              <div class="add-cross-price" v-if="myChoose.tags.promPrice">
                <img :src="unionIcon" alt="" />
                <span>{{ parseFloat(((myChoose.tags.salePrice ? myChoose.tags.salePrice : myChoose.price) * unionScale).toFixed(2) || 0) }}</span>
              </div>
            </div>
            <p class="goods-price" v-else>
              <img :src="unionIcon" alt="" />
              <span>{{ parseFloat((myChoose.price * unionScale).toFixed(2) || 0) }}</span>
            </p> -->
            <GoodsPrice
              :info="myChoose"
              :price="myChoose.hasPromoTags && myChoose.tags.promPrice ? myChoose.tags.promPrice : myChoose.price"
              :unionIcon="unionIcon"
              :crossedPrice="
                myChoose.hasPromoTags && myChoose.tags.promPrice ?
                myChoose.tags.salePrice || myChoose.price : ''
              "
              :isShowIcon="true"
              :isSkuPanel="true"
            ></GoodsPrice>
            <GoodsLabel
              :data="myChoose.promoTags"
              v-if="myChoose.hasPromoTags && handleTags(myChoose.promoTags) && handleTags(myChoose.promoTags).length > 0"
            ></GoodsLabel>
            <!-- <p class="my-choose">
              {{ TLang("已选", "cart") }}：{{ myChoose.specValue1 || myChoose.specName }}
            </p> -->
            <p
              :class="['pre-sale ',]"
              v-if="myChoose.advanceSale"
            >
              <span class="pre-sale-title">{{ TLang("预售", "cart") }}</span>
              <span class="pre-sale-subTitle">{{ TLang("preSale", "cart") }}{{ transformDate(myChoose.sendGoodsTimeStart) }}{{ TLang("preSale2", "cart") }}</span>
            </p>
          </div>
        </section>
      </div>
      <div class="spec-title">{{ TLang("规格", "cart") }}</div>
      <section
        class="standard"
        v-if="goods && goods.goodsSpecList && goods.goodsSpecList.length"
      >
        <!-- <h4>{{ TLang("规格", "cart") }}</h4> -->
        <ul>
          <li
            v-for="spec in goods.goodsSpecList"
            :key="spec.goodsId"
            :class="{
              active: spec.goodsId === myChoose.goodsId,
              disable:
                (spec.gray &&
                  (spec.bizStock === null || spec.bizStock === undefined)) ||
                spec.bizStock === 0,
            }"
            @click="chooseSku(spec)"
          >
            {{ spec.specValue1 || spec.specName }}
          </li>
        </ul>
      </section>
      <div class="footerBottom">
        <section class="choose-num">
          <h4>{{ TLang("数量", "cart") }}</h4>
          <div class="num-info">
            <span
              class="max-num-toast"
              v-if="myChoose.buyLimit > 0 || myChoose.buyMin > 1"
            >
              <span v-if="myChoose.buyMin > 1" class="limitTip">{{ TLang("起购1", "cart") }}{{ myChoose.buyMin }}{{ TLang("起购2", "cart") }}</span>
              <span v-if="myChoose.buyLimit > 0 && myChoose.buyMin > 1" class="limitSpace"></span>
              <span v-if="myChoose.buyLimit > 0" class="limitTip">{{ TLang("限购1", "cart") }}{{ myChoose.buyLimit }}{{ TLang("限购2", "cart") }}</span>

            </span>
            <div class="choose-num-btn">
              <button
                class="choose-btn"
                type="button"
                :disabled="
                  num <= 1 || (myChoose.buyMin && num <= myChoose.buyMin)
                "
                @click="num--;gioClick('数量')"
              >
                -
              </button>

              <input type="number" class="num" v-model="num" @change="setNum" />

              <button
                class="choose-btn"
                type="button"
                :disabled="
                  (myChoose.buyLimit && num >= myChoose.buyLimit) ||
                  (num > myChoose.availableStockNum &&
                    (myChoose.bizStock === null ||
                      myChoose.bizStock === undefined)) ||
                  (num >= myChoose.bizStock && myChoose.bizStock > 0) ||
                  myChoose.bizStock === 0
                "
                @click="num++;gioClick('数量')"
              >
                +
              </button>
            </div>
          </div>
        </section>
        <section
          class="add-cart-btn-wrap"
          :class="{'add-cart-btn-wrap-disable': !myChoose.goodsId || myChoose.gray || myChoose.bizStock === 0}"
        >
          <button type="button" @click="addToCart">{{ TLang("加入购物车", "cart") }}</button>
        </section>
      </div>
      <section
        class="close-modal"
        @click="
          $emit('onClose');
          num = 1;
          gioClick('关闭');
        "
      >
        <img src="../assets/imgs/add_cart_close.png" alt="" />
      </section>
    </van-actionsheet>

      <div v-if="showMaxImg" class="img-logo-model" @click="changeShowMaxImg">
        <div class="img-logo">
          <img :src="myChoose.imgUrl" alt="" />
        </div>
      </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import fudou from "../assets/imgs/fudou.png";
import GoodsLabel from "./GoodsLabel";
import PromoSticker from "./PromoSticker";
import BusinessCoupon from "./BusinessCoupon";
import GoodsPrice from "./GoodsPrice";
import {
  checkUnifyShop,
  unionFlag,
  gioClickHandle,
  getFilterParam,
} from "../utils";
import { publicFunc } from "../utils/func";
import { mapState } from "vuex";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    goods: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    GoodsLabel,
    PromoSticker,
    BusinessCoupon,
    GoodsPrice,
  },
  data() {
    return {
      myChoose: {},
      num: 1,
      unionIcon: window.union_icon || fudou,
      unionScale: window.union_scale || 1,
      isShowIcon: true,
      fontSize: "large",
      showMaxImg:false
    };
  },
  watch: {
    goods: function (props) {
      if (props.goodsSpecList && props.goodsSpecList.length) {
        props.goodsSpecList.map((sku) => {
          // console.log("sku",sku);
          if (sku.goodsId === props.id) {
            
            this.myChoose = sku;
            // console.log("goodsId",sku,this.myChoose);
            if (this.myChoose.buyMin > 0) {
              this.num = this.myChoose.buyMin;
            }
          }
        });
      }
    },
  },
  computed: {
    orderInfo() {
      return new Date().getHours() < this.myChoose.cutOffTimeStr.split(":")[0]
        ? `${this.myChoose.cutOffTimeStr}前（含${this.myChoose.cutOffTimeStr})下单，可选今日发货`
        : `${this.myChoose.cutOffTimeStr}后下单，可选次日起发货`;
    },
    ...mapState({
      allQuery: (state) => state.allQuery,
    }),
  },
  methods: {
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    changeShowMaxImg(){
      this.showMaxImg = !this.showMaxImg
    },
    /**
     * 日期格式化
     * @param { String } time 日期
     */
    transformDate(time) {
      if (time) {
        const date = new Date(time);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        return year + "-" + month + "-" + day;
      }
    },

    /**
     * 选择规格
     * @param { Object }  规格
     */
    chooseSku(sku) {
      if (sku.gray && (sku.bizStock === null || sku.bizStock === undefined))
        return;
      this.myChoose = sku;
      this.num = sku.buyMin;
      this.gioClick("规格");
    },

    handleTags(tags) {
      // console.log(tags)
      const resultArr = [];
      tags && tags.length > 0 && tags.forEach((item)=>{
        if(![9003, 9004, 9005, 9006].includes(item.mktFrontType)){
          resultArr.push(item);
        }
      })
      return resultArr;
    },

    setNum() {
      // console.log("zheshishuliang")
      const { stockNum, buyLimit, buyMin, availableStockNum, bizStock } =
        this.myChoose;
      if (this.num < 1 || !this.num) {
        this.num = buyMin || 1;
        return;
      }
      if (
        typeof bizStock === "number" &&
        bizStock >= 0 &&
        this.num > bizStock
      ) {
        this.num = bizStock;
        Toast(`抱歉，该商品仅剩${bizStock}件了`);
        return;
      }
      if (this.num > availableStockNum) {
        if (buyLimit && this.num >= buyLimit && buyLimit <= availableStockNum) {
          this.num = buyLimit;
          return;
        }
        this.num = availableStockNum;
        Toast(`抱歉，该商品仅剩${availableStockNum}件了`);
        return;
      }
      if (buyLimit && this.num >= buyLimit) {
        this.num = buyLimit;
        return;
      }
      if (buyMin && this.num < buyMin) {
        this.num = buyMin;
        Toast(`该商品${buyMin}件起购`);
        return;
      }
      this.num = parseInt(this.num, 10);
      this.gioClick("数量");
    },

    addToCart() {
      const { categoryId, goodsId, gray, bizStock } = this.myChoose;
      if (!categoryId && !goodsId || gray || bizStock === 0) return
      const myChoose = {
        categoryId,
        goodsId,
        goodsNum: this.num,
      };
      this.$emit("onClose");
      this.$emit("addCart", myChoose);
      this.num = 1;
      this.myChoose = {};
      this.gioClick("加入购物车");
    },
    gioClick(elementName){
      let price = null;
      if(this.myChoose.hasPromoTags){
        price = this.myChoose.tags.promPrice || this.myChoose.price;
      } else {
        price = parseFloat(this.myChoose.price * this.unionScale).toFixed(2) || 0
      }
      // console.log("this.myChoose",this.myChoose, price);
      // 公共添加
      const paramsCommon = {
        df_modulename: "多规格面板",
        df_elementname: elementName,
        df_contentTitle: "搜索结果",
        df_goodsid: this.myChoose.goodsId,
        df_goodsname: this.goods.name,
        df_transform: "搜索",
        df_searchKeyword: this.allQuery.key,
        df_orderAmount: price,
        df_goodsChannel: this.goods.gioChannelName, //channelName
        df_goodsChannelId: this.goods.gioChannel,
      }
       // filter添加
       let filterObj = {};
        if (this.allQuery){
            filterObj = {df_filter: getFilterParam(this.allQuery)};
        }
      gioClickHandle(
          "DF_elementClick",
          Object.assign({}, paramsCommon, filterObj),
        );
    }
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.add-cart {
  .van-popup {
    border-radius: 12px * @375 12px * @375 0px 0px;
    // padding: 12px;
    box-sizing: border-box;
    height: 60vh;
    width: 100%;
    overflow: hidden;
  }
  .van-popup--bottom {
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
  }
  .van-actionsheet__content {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .header-part {
    width: 100%;
    padding: 30px * @375 15px * @375 10px * @375;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .goods-info {
    display: flex;
  }
  .goods-img {
    width: 90px * @375;
    height: 90px * @375;
    border-radius: 4px * @375;
    border: 1px * @375 solid #E5E5E5;
    margin-right: 10px * @375;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-price-wrap {
    width: calc(100% - 100px * @375);
  }
  .goods-price {
    margin-bottom: 7px;
    display: flex;
    font-size: 18px;
    color: #f44545;
    align-items: center;
    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }
  .promo-price-wrap {
    padding-bottom: 6px * @375;
  
    .add-promo-price {
      display: flex;
      align-items: center;
      line-height: 0;
      img {
        width: 12px * @375;
        height: 12px * @375;
        display: block;
      }
      span {
        font-size: 18px * @375;
        font-weight: 600;
        color: #FF5757;
        line-height: 18px * @375;
      }
    }
    .add-cross-price {
      display: flex;
      align-items: center;
      line-height: 0;
      img {
        width: 12px * @375;
        height: 12px * @375;
        display: block;
        filter: gray; /* 兼容 IE6-9 的滤镜 */
        filter: grayscale(.95); // 对图片进行灰度转换
        -webkit-filter: grayscale(.95);
      }
      span {
        font-size: 12px * @375;
        font-weight: 400;
        color: #999999;
        line-height: 12px * @375;
        text-decoration: line-through;
      }
    }
  }
  .my-choose {
    font-size: 12px;
    color: #333;
    max-width: 200px;
  }
  .pre-sale {
    // background: url(../assets/imgs/presale-long.png) 0 0 no-repeat;
    // background-size: 100% 20px;
    font-size: 12px !important;
    // color: #fff;
    // padding-left: 45px;
    margin-top: 5px * @375;
    display: flex;
    align-items: center;
    .pre-sale-title {
      display: block;
      height: 16px * @375;
      font-size: 12px * @375;
      font-weight: 400;
      color: #FFF;
      line-height: 16px * @375;
      padding: 0 2px * @375;
      background: #3FA6FF;
      border: 1px * @375 solid #3FA6FF;
      border-radius: 2px * @375 0 0 2px * @375;
      border-right: none;
    }
    .pre-sale-subTitle {
      display: block;
      height: 16px * @375;
      font-size: 12px * @375;
      font-weight: 400;
      color: #3FA6FF;
      line-height: 16px * @375;
      padding: 0 2px * @375;
      border-radius: 0 2px * @375 2px * @375 0;
      border: 1px * @375 solid #3FA6FF;
    }
   }
  // .pre-sale-en {
  //   background: url(../assets/imgs/presale-long-en.png) 0 0 no-repeat;
  //   background-size: 100% 20px;
  // }
  .spec-title {
    font-size: 14px * @375;
    font-weight: 400;
    color: #999;
    line-height: 19px * @375;
    padding: 0 15px * @375 10px * @375;
    flex-shrink: 0;
  }
  .standard {
    overflow-y: auto;
    height: 100%;
    padding: 0 15px * @375;
    // border-bottom: 1px solid #e5e5e5;
    h4 {
      font-size: 12px;
      color: #999;
      margin-bottom: 12px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
    }
    li {
      font-size: 14px * @375;
      color: #333;
      line-height: 20px * @375;
      padding: 8px * @375 10px * @375;
      border: 1px * @375 solid #e5e5e5;
      margin-bottom: 10px * @375;
      margin-right: 10px * @375;
      flex-shrink: 0;
      border-radius: 2px * @375;
      &.active {
        border-color: #3FA6FF;
        color: #3FA6FF;
      }
      &.disable {
        color: #999;
        background: #F7F7F7;
        border: 1px * @375 solid #E5E5E5;
      }
    }
  }

  .ship-info {
    display: flex;
    height: 40px;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    h4 {
      font-size: 12px;
      color: #999;
      margin-right: 12px;
    }
    .detail {
      font-size: 12px;
      color: #333;
    }
  }

  .footerBottom {
    flex-shrink: 0;
  }
  .choose-num {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px * @375 15px * @375;
    border-bottom: 1px solid #e5e5e5;
    h4 {
      font-size: 14px * @375;
      font-weight: 400;
      color: #999999;
      line-height: 19px * @375;
    }
    .num-info {
      display: flex;
      align-items: center;
    }
    .max-num-toast {
      font-size: 12px * @375;
      margin-right: 8px * @375;
      .limitTip {
        height: 16px * @375;
        border-radius: 2px * @375;
        padding: 0 2px * @375;
        font-size: 14px * @375;
        font-weight: 400;
        color: #A037E5;
        line-height: 16px * @375;
      }
      .limitSpace {
        margin-right: 2px * @375;
      }
    }
    .choose-num-btn {
      border: 1px * @375 solid #ccc;
      border-radius: 2px * @375;
      display: flex;
      align-items: center;
      // height: 28px;
      text-align: center;
      font-size: 14px;
    }
    .choose-btn {
      width: 28px * @375;
      color: #333333;
      border: none;
      background: #fff;
      height: 28px * @375;
      line-height: 28px * @375;
      &:disabled {
        color: #ccc;
        background: #f7f7f7;
      }
      // &.disabled {
      //   color: #b2b2b2;
      // }
    }
    .num {
      width: 34px * @375;
      border: 1px * @375 solid #ccc;
      border-top: none;
      border-bottom: none;
      font-size: 12px * @375;
      color: #333333;
      text-align: center;
      height: 28px * @375;
      line-height: 28px * @375;
      border-radius: 0;
      // padding: 6px 0;
    }
  }
  .add-cart-btn-wrap {
    padding: 10px * @375 15px * @375;
    button {
      border: none;
      background: #3FA6FF;
      border-radius: 4px * @375;
      text-align: center;
      font-size: 16px * @375;
      color: #fff;
      height: 44px * @375;
      line-height: 44px * @375;
      display: block;
      width: 100%;
    }
  }
  .add-cart-btn-wrap-disable {
    opacity: 0.5;
  }

  .close-modal {
    position: absolute;
    top: 15px * @375;
    right: 15px * @375;
    width: 18px * @375;
    height: 18px * @375;
    line-height: 0;
    img {
      width: 18px * @375;
      height: 18px * @375;
      display: block;
    }
  }
}

.img-logo-model {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  left: 0px;
  top: 0px;
  z-index: 9999;
  .img-logo {
    position: fixed;
    display: flex;
    width: 100%;
    height: 100vh;
    align-items: center;
    left: 0px;
    z-index: 9991;
    text-align: center;
    & > img {
      max-width: 100%;
      height: auto !important;
    }
  }
}

</style>
